// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1mZsp","title":"AfterBackImages_title__qugX6","images":"AfterBackImages_images__26mH6"};